import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { sendFromIFrame } from 'utils/send-from-iframe';

export const useIframeMessage = (iframeId: string) => {
    const dispatch = useDispatch();

    useEffect(() => {
        const controller = new AbortController();
        if (!isSSR) {
            window.addEventListener(
                'message',
                (e) => {
                    let data = null;
                    try {
                        data = JSON.parse(e.data);
                    } catch {
                        data = null;
                    }

                    if (isIframeMessage(data, iframeId)) {
                        Object.keys(data).forEach((key) => {
                            if (key !== 'type') {
                                const payload = data[key];
                                if (key === 'LESSON_VIEW.TOGGLE_MODAL') {
                                    dispatch({ type: 'LESSON_VIEW.TOGGLE_MODAL', shouldShowModal: payload });
                                } else if (key === 'LESSON_VIEW.SET_SELECTED_STUDENT_ID') {
                                    dispatch({
                                        type: 'LESSON_VIEW.SET_SELECTED_STUDENT_ID',
                                        selectedStudentId: payload,
                                    });
                                } else {
                                    dispatch({ type: key, payload });
                                }
                            }
                        });
                    }
                },
                { signal: controller.signal }
            );
        }

        return () => controller.abort();
    }, [dispatch, iframeId]);

    return sendFromIFrame;
};

function isIframeMessage(data: unknown, iframeId: string) {
    return data !== null && typeof data === 'object' && 'type' in data && data.type === iframeId;
}
